import React, {Component} from 'react';
import {Link,Redirect} from "react-router-dom";
        import $ from 'jquery';
        import Header from './../../Header';
        import HeaderMob from './../../HeaderMob';
        import CryptoJS from 'crypto-js';
        import config from 'react-global-configuration';
import ContentLoader from'./contentLoader';
import moment from 'moment';

        class CustomerDetails extends Component {
        constructor() {
        super();
                var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data?this.decrypt(localStorage.getItem('encdata'),0):'';
                this.state = {
                data: [],
                        applications: [],
                        login_details: [],
                        upload_details: [],
                        packageData: [],
                        package_name:'',
                        apiKey:'',
                        apiKeyStatus:'',
                        count: '',
                        key: 1,
                        packageData: '',
//            bandwidth_log:'',
                        storage:'',
                        currency:[],
                        andr_fcm_key: '',
                        andr_deep_link_code: '',
                        andr_client_id: '',
                        andr_client_secret: '',
                        andr_force_update_version: '',
                        andr_refresh_token: '',
                        ios_fcm_key: '',
                        ios_deep_link_code: '',
                        ios_secret_code: '',
                        ios_force_update_version: '',
                        ios_mode: '',
                        roku_sandbox_key: '',
                        roku_production_key: '',
                        roku_force_update_version: '',
                        roku_android_mode: '',
                        edit_access: '',
                        android_view_state: 1,
                        ios_view_state: 1,
                        roku_view_state: 1,
                        apple_view_state: 1,
                        fire_view_state: 1,
                        android_id: '',
                        android_config_id: '',
                        ios_config_id: '',
                        roku_config_id: '',
                        apple_config_id: '',
                        android_version_code_id: '',
                        ios_version_code_id: '',
                        roku_version_code_id: '',
            subadmin_count: '',
            account_manager:[],
            cards_list:'',
            payment_method:'',
            revenue_last_month:'',
            amount_paid_till_now:'',
            total_no_of_subscribed_users:'',
            enduser_count:'',
            loader:1,
                        apiUrl:this.decryptconfigdata('apiUrl'),
                        studioUrl:this.decryptconfigdata('studioUrl'),
                        userAuthKey:has_local_data?localdata.user_key:'',
            userId:has_local_data?localdata.user_id:'',
            local_data:has_local_data?this.decrypt(localStorage.getItem('encdata'),0):'',
            get_bandwidth_api : 0,
            bandwidth:'',
                };
                this.getCustomerDetails = this.getCustomerDetails.bind(this);
                this.onChange = this.onChange.bind(this);
                this.onChangeaction = this.onChangeaction.bind(this);
                this.handleKeyUp = this.keyUpHandler.bind(this);
        }
        decryptconfigdata(configkey){
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
                var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
                var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
                iv
                });
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                return plaintext;
        }

        decrypt(findresponse, flg){
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
                var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
                var res = flg ? findresponse.encdata : findresponse;
                var bytes = CryptoJS.AES.decrypt(res, key, {
                iv
                });
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                return JSON.parse(plaintext);
        }
        rawjsonparse(findresponse, flg) {
        return findresponse;
        }
    goToCustomerStore(email,password,studio_id){
        if(window.confirm('Are you sure to login this store')) {
            var win = window.open(this.state.studioUrl+"/login/storeLogin/email/"+email+"/password/"+password+"/studio_id/"+studio_id, '_blank');
                win.focus()
        }
        }
  
    onChange(propertyName,event){
        this.setState({package_name: event.target.value}, function () {
        //this.getCustomers();
        });
        }
        toggle1() {
        $('#sdk_change').hide();
                $('#sdk_change_save').show();
                $('#sdk_name').hide();
                $('#sdk_span_txt').show();
        }
        toggle2() {

        var sdk_name= $('#sdk_name_txt').val();
        if(sdk_name=='')
        {
        alert("Sdk name can not be empty");
                return false;
        }
        else {
            if(window.confirm('Are you sure to update the sdk name ?')) {
            var studios_id= $('#studios_id').val();
            $.post(this.state.apiUrl + '/adminRest/updatesdk',{'sdk_name':sdk_name,'studio_id':studios_id,'userAuthKey':this.state.userAuthKey},function(res){
                $('#sdk_change').show();
                        $('#sdk_change_save').hide();
                        $('#sdk_name').show();
                        $('#sdk_span_txt').hide();
                });
                this.getCustomerDetails();
        }

        }
        }

        disabletoken() {
        if(window.confirm('Are you sure, you want to disable the API Key for this studio?')) {
        var studios_id= $('#studios_id').val();
        $.post(this.state.apiUrl + '/adminRest/disableApiKey',{'studio_id':studios_id,'userAuthKey':this.state.userAuthKey},function(res){
                });
        }
        this.getCustomerDetails();
        }

        generatetoken() {
        if(window.confirm('Are you sure, you want to create the API Key for this studio?')) {
        var studios_id= $('#studios_id').val();
        $.post(this.state.apiUrl + '/adminRest/GenerateApiKey',{'studio_id':studios_id,'userAuthKey':this.state.userAuthKey},function(res){
                });
        }
        this.getCustomerDetails();
        }

        keyUpHandler() {
        $('.force_update_version').keyup(function(){
        var val = $(this).val();
                if (isNaN(val)){
        val = val.replace(/[^0-9\.]/g, '');
                if (val.split('.').length > 5)
                val = val.replace(/\.+$/, "");
        }
        $(this).val(val);
        });
        }

        getCustomerDetails(){
        $(document).ready(function(){
        });
        fetch(this.state.apiUrl + '/adminRest/ViewDetail/studioId/'+this.props.match.params.studioId+'/userId/'+this.state.userId+'/userAuthKey/'+ this.state.userAuthKey, {
                method: 'POST',
                        dataType: 'json',
                        body: JSON.stringify(this.state),
                })
                .then((Response) => Response.json())
                .then((findresponse) =>
                {
                $(document).ready(function(){
                });
            findresponse = this.rawjsonparse(findresponse,1);
                        this.setState({
                data: findresponse.data[0],
                applications : findresponse.applications,
                account_manager: findresponse.account_manager_data,
                loader: 0,
            })
        })
    }
    otherBillingDetails(){
        fetch(this.state.apiUrl + '/adminRest/otherBillingDetails/studioId/'+this.props.match.params.studioId+'/userAuthKey/'+ this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
        .then((findresponse) =>
        {
            findresponse = this.rawjsonparse(findresponse,1); 
            this.setState({
                package_name: findresponse.package_name,
//                bandwidth_log: findresponse.bandwidth_log,
                storage:findresponse.storage,
                currency:findresponse.currency,
                apiKey: findresponse.apiKey,
                apiKeyStatus: findresponse.apiKeyStatus,
                subadmin_count: findresponse.subadmin_count,
                cards_list: findresponse.cards_list,
                payment_method: findresponse.payment_method,
                revenue_last_month: findresponse.revenue_last_month,
                total_no_of_subscribed_users: findresponse.total_no_of_subscribed_users,
                enduser_count: findresponse.enduser_count,
            })
        })
        .then(() => {
                            this.getBandwidthDetails();
                })
    }
    showLoginDetails(){
        fetch(this.state.apiUrl + '/adminRest/showLoginDetails/studioId/'+this.props.match.params.studioId+'/userAuthKey/'+ this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
        .then((findresponse) =>
        {
            findresponse = this.rawjsonparse(findresponse,1); 
            this.setState({
                login_details: findresponse.login_details,
                
            })
        })
    }
    customerDeepLinking(){
        fetch(this.state.apiUrl + '/adminRest/customerDeepLinking/studioId/'+this.props.match.params.studioId+'/userId/'+this.state.userId+'/userAuthKey/'+ this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
        .then((findresponse) =>
        {
            findresponse = this.rawjsonparse(findresponse,1); 
            this.setState({
                        android_id: findresponse.android_data.android_id,
                                andr_fcm_key: findresponse.android_data.fcm_key,
                                andr_deep_link_code: findresponse.android_data.deep_link_code,
                                android_config_id: findresponse.android_data.android_config_id,
                                andr_client_id: findresponse.android_data.client_id,
                                andr_client_secret: findresponse.android_data.client_secret,
                                andr_refresh_token: findresponse.android_data.refresh_token,
                                android_version_code_id: findresponse.android_data.android_version_code_id,
                                andr_force_update_version: findresponse.android_data.version_code,
                                ios_fcm_key: findresponse.ios_data.fcm_key,
                                ios_deep_link_code: findresponse.ios_data.deep_link_code,
                                ios_config_id: findresponse.ios_data.ios_config_id,
                                ios_secret_code: findresponse.ios_data.secreat_code,
                                ios_mode: findresponse.ios_data.ios_mode,
                                ios_version_code_id: findresponse.ios_data.ios_version_code_id,
                                ios_force_update_version: findresponse.ios_data.version_code,
                                roku_config_id: findresponse.roku_data.roku_config_id,
                                roku_sandbox_key: findresponse.roku_data.sandbox_code,
                                roku_production_key: findresponse.roku_data.production_code,
                                roku_mode: findresponse.roku_data.roku_mode,
                                roku_version_code_id: findresponse.roku_data.roku_version_code_id,
                                roku_force_update_version: findresponse.roku_data.version_code,
                                user_permission: findresponse.user_permission,
                
                        })
                })
        }

        showUploadDetails(){
        fetch(this.state.apiUrl + '/adminRest/showUploadDetails/studioId/'+this.props.match.params.studioId+'/userAuthKey/'+ this.state.userAuthKey, {
        method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
        })
                .then((Response) => Response.json())
                .then((findresponse) =>
                {
            findresponse = this.rawjsonparse(findresponse,1); 
                        this.setState({
                        upload_details: findresponse.upload_details,
                                count: findresponse.count,
                        })
                })
        }

        getuploaddetails(){
        return (
<div class="list_check">
    <div class="tickets hidden-sm">
        <ul class="tickets_head">
            <li class="intra_col_20">File Name</li>
            <li class="intra_col_13">Upload Start time</li>
            <li class="intra_col_13">Upload End Time</li>
            <li class="intra_col_15">Upload Cancel Time</li>
            <li class="intra_col_13">Encode Start Time</li>
            <li class="intra_col_13">Encode End Time</li>
            <li class="intra_col_13">Encode Fail Time</li>
        </ul>
                {this.state.upload_details.map((upload_details,key)=>
        <ul class="tickets_number">       
            <li class="intra_col_20">{upload_details.film_name}</li>
            <li class="intra_col_13">{upload_details.upload_start_time}</li>
            <li class="intra_col_13">{upload_details.upload_end_time}</li>
            <li class="intra_col_15">{upload_details.upload_cancel_time}</li>
            <li class="intra_col_13">{upload_details.encoding_start_time}</li>
            <li class="intra_col_13">{upload_details.encoding_end_time}</li>
            <li class="intra_col_13">{upload_details.encode_fail_time}</li>        
        </ul>
                        )}  
    </div>

    <div class="customer_mob hidden-md">
        {
                this.state.upload_details.map((upload_details,key)=>
             
        <div class="custmer_list_mob">
            <h4 class="list_title">{upload_details.film_name}</h4>
            <div class="wrap">{upload_details.upload_start_time}</div>
        </div>
                        )
        }

    </div>
</div>

                )

        }

        getcardDetails(is_subscribed, status, deleted, is_default){
        return(
<div class="card">
    <h5>Card Details</h5>
    <div class="card-details">
                        {this.state.data.map((data,key)=>  
        <div class="card-info">                           
            <div class="pull-left">
                <h6>{data.card_last_fourdigit}</h6>
                <h5>{data.card_holder_name}</h5>
            </div>
            <div class="pull-right">
                <h5>Valid Thu</h5>
                <h6>{data.cancelled_date ? data.cancelled_date : 'N/A'}</h6>
            </div>
        </div>
                        )}
    </div>
</div>

                )
        }
        
        getRevenue(){
        if(this.state.currency.length>0){
        return(
<select class="form-control customer_form-control">
                {this.state.currency.map((currency,key)=>
    <option value="">{currency.symbol} {currency.amount}</option>
                        )}
</select>
                )
        }
        }

        onChangeaction(propertyName, event) {
        if (propertyName == "andr_fcm_key"){
        propertyName = event.target.value;
                this.setState({ andr_fcm_key: propertyName });
        }
        if (propertyName == "andr_deep_link_code"){
        propertyName = event.target.value;
                this.setState({ andr_deep_link_code: propertyName });
        }
        if (propertyName == "andr_client_id"){
        propertyName = event.target.value;
                this.setState({ andr_client_id: propertyName });
        }
        if (propertyName == "andr_client_secret"){
        propertyName = event.target.value;
                this.setState({ andr_client_secret: propertyName });
        }
        if (propertyName == "andr_force_update_version"){
        propertyName = event.target.value;
                this.setState({ andr_force_update_version: propertyName });
        }
        if (propertyName == "andr_refresh_token"){
        propertyName = event.target.value;
                this.setState({ andr_refresh_token: propertyName });
        }
        if (propertyName == "ios_fcm_key"){
        propertyName = event.target.value;
                this.setState({ ios_fcm_key: propertyName });
        }
        if (propertyName == "ios_deep_link_code"){
        propertyName = event.target.value;
                this.setState({ ios_deep_link_code: propertyName });
        }
        if (propertyName == "ios_secret_code"){
        propertyName = event.target.value;
                this.setState({ ios_secret_code: propertyName });
        }
        if (propertyName == "ios_force_update_version"){
        propertyName = event.target.value;
                this.setState({ ios_force_update_version: propertyName });
        }
        if (propertyName == "ios_mode"){
        propertyName = event.target.value;
                this.setState({ ios_mode: propertyName });
        }
        if (propertyName == "roku_sandbox_key"){
        propertyName = event.target.value;
                this.setState({ roku_sandbox_key: propertyName });
        }
        if (propertyName == "roku_production_key"){
        propertyName = event.target.value;
                this.setState({ roku_production_key: propertyName });
        }
        if (propertyName == "roku_force_update_version"){
        propertyName = event.target.value;
                this.setState({ roku_force_update_version: propertyName });
        }
        if (propertyName == "roku_mode"){
        propertyName = event.target.value;
                this.setState({ roku_mode: propertyName });
        }
        }
        android_edit(){
        { this.state.user_permission == 1 ? this.setState({ android_view_state: 0 }) : alert("You don't have sufficient permission to edit this form."); }
        }
        ios_edit(){
        { this.state.user_permission == 1 ? this.setState({ ios_view_state: 0 }) : alert("You don't have sufficient permission to edit this form."); }
        }
        roku_edit(){
        { this.state.user_permission == 1 ? this.setState({ roku_view_state: 0 }) : alert("You don't have sufficient permission to edit this form."); }
        }
        apple_edit(){
        { this.state.user_permission == 1 ? this.setState({ apple_view_state: 0 }) : alert("You don't have sufficient permission to edit this form."); }
        }
        fire_edit(){
        { this.state.user_permission == 1 ? this.setState({ fire_view_state: 0 }) : alert("You don't have sufficient permission to edit this form."); }
        }
        updateAppSettings(){
        var andoid_chk = this.state.andr_force_update_version = this.state.andr_force_update_version.replace(/[^0-9\.]/g, '');
        var andoid_chk = andoid_chk[andoid_chk.length -1];
        this.state.andr_force_update_version = andoid_chk == '.'? this.state.andr_force_update_version.slice(0,-1) : this.state.andr_force_update_version;
                document.getElementById("android_form_update").innerHTML = "Sending....";
                document.getElementById("android_form_update").disabled = true;
                const fd = new FormData;
                fd.append('andr_fcm_key', this.state.andr_fcm_key);
                fd.append('andr_deep_link_code', this.state.andr_deep_link_code);
                fd.append('andr_client_id', this.state.andr_client_id);
                fd.append('andr_client_secret', this.state.andr_client_secret);
                fd.append('andr_force_update_version', this.state.andr_force_update_version);
                fd.append('andr_refresh_token', this.state.andr_refresh_token);
                fd.append('android_fcm_id', this.state.android_id);
                fd.append('android_config_id', this.state.android_config_id);
                fd.append('android_version_code_id', this.state.android_version_code_id);
                fetch(this.state.apiUrl + '/adminRest/AppSettings/studioId/' + this.props.match.params.studioId + '/userAuthKey/' + this.state.userAuthKey, {
                method: 'POST',
                        dataType: 'json',
                        body: fd,
                })
                .then((Response) => Response.json())
                .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                        console.log(findresponse);
                        document.getElementById("android_form_update").disabled = false;
                        document.getElementById("android_form_update").innerHTML = "Update";
                        this.setState({ android_view_state: 1 });
                        if (findresponse.code == 200) {
                this.setState({message: findresponse.msg}, function () {
                });
                } else {
                this.setState({message: findresponse.msg})
                }
                })
        }
        updateiosAppSettings(){
        var ios_chk =this.state.ios_force_update_version = this.state.ios_force_update_version.replace(/[^0-9\.]/g, '');
        var ios_chk = ios_chk[ios_chk.length -1];
        this.state.ios_force_update_version = ios_chk == '.' ? this.state.ios_force_update_version.slice(0,-1) : this.state.ios_force_update_version;
                document.getElementById("ios_form_update").innerHTML = "Sending....";
                document.getElementById("ios_form_update").disabled = true;
                const fd = new FormData;
                fd.append('ios_fcm_key', this.state.ios_fcm_key);
                fd.append('ios_deep_link_code', this.state.ios_deep_link_code);
                fd.append('ios_secret_code', this.state.ios_secret_code);
                fd.append('ios_force_update_version', this.state.ios_force_update_version);
                fd.append('ios_mode', this.state.ios_mode);
                fd.append('ios_fcm_id', this.state.android_id);
                fd.append('ios_config_id', this.state.ios_config_id);
                fd.append('ios_version_code_id', this.state.ios_version_code_id);
                fetch(this.state.apiUrl + '/adminRest/AppSettings/studioId/' + this.props.match.params.studioId + '/userAuthKey/' + this.state.userAuthKey, {
                method: 'POST',
                        dataType: 'json',
                        body: fd,
                })
                .then((Response) => Response.json())
                .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                        console.log(findresponse);
                        document.getElementById("ios_form_update").disabled = false;
                        document.getElementById("ios_form_update").innerHTML = "Update";
                        this.setState({ ios_view_state: 1 });
                        if (findresponse.code == 200) {
                this.setState({message: findresponse.msg}, function () {
                });
                } else {
                this.setState({message: findresponse.msg})
                }
                })
        }
        updateRokuAppSettings(){
        var roku_chk = this.state.roku_force_update_version = this.state.roku_force_update_version.replace(/[^0-9\.]/g, '');
        var roku_chk = roku_chk[roku_chk.length -1];
        this.state.roku_force_update_version = roku_chk == '.' ? this.state.roku_force_update_version.slice(0,-1) : this.state.roku_force_update_version;
                document.getElementById("roku_form_update").innerHTML = "Sending....";
                document.getElementById("roku_form_update").disabled = true;
                const fd = new FormData;
                fd.append('roku_config_id', this.state.roku_config_id);
                fd.append('roku_sandbox_key', this.state.roku_sandbox_key);
                fd.append('roku_production_key', this.state.roku_production_key);
                fd.append('roku_version_code_id', this.state.roku_version_code_id);
                fd.append('roku_force_update_version', this.state.roku_force_update_version);
                fd.append('roku_mode', this.state.roku_mode);
                fetch(this.state.apiUrl + '/adminRest/AppSettings/studioId/' + this.props.match.params.studioId + '/userAuthKey/' + this.state.userAuthKey, {
                method: 'POST',
                        dataType: 'json',
                        body: fd,
                })
                .then((Response) => Response.json())
                .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                        console.log(findresponse);
                        document.getElementById("roku_form_update").disabled = false;
                        document.getElementById("roku_form_update").innerHTML = "Update";
                        this.setState({ roku_view_state: 1 });
                        if (findresponse.code == 200) {
                this.setState({message: findresponse.msg}, function () {
                });
                } else {
                this.setState({message: findresponse.msg})
                }
                })
        }

        getViewAndroidInfo(){
        return (
<div class="row">
    <span class="emps_edit conf_edit"><a href="javascript:void(0);" class="btn btn-trans Medium" onClick={this.android_edit.bind(this)} > <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit</a></span>
    <div class="col-md-12 app_tv_form">
        <div class="form-group row">
            <label for="tvapp" class="col-sm-5 col-form-label app-label">FCM Key:</label>
            <div class="col-sm-6 col-xs-12">
                <span class="view_app_info app-field-lbl">{this.state.andr_fcm_key}</span>
            </div>
        </div>
        <div class="form-group row">
            <label for="tvapp" class="col-sm-5 col-form-label app-label">Deeplink Code:</label>
            <div class="col-sm-6 col-xs-12">
                <span class="view_app_info app-field-lbl">{this.state.andr_deep_link_code}</span>
            </div>
        </div>
        <span class="job_title shared_secret app-label">In-app Credentials:</span>
        <div class="secret_ky">
            <div class="form-group row">
                <label for="tvapp" class="col-sm-4 col-form-label app-label">Client ID:</label>
                <div class="col-sm-7 col-xs-12 inpt_bx">
                    <span class="view_app_info app-field-lbl">{this.state.andr_client_id}</span>
                </div>
            </div>
            <div class="form-group row">
                <label for="tvapp" class="col-sm-4 col-form-label app-label">Client Secret:</label>
                <div class="col-sm-7 col-xs-12 inpt_bx">
                    <span class="view_app_info app-field-lbl">{this.state.andr_client_secret}</span>                                                                </div>
            </div>
            <div class="form-group row">
                <label for="tvapp" class="col-sm-4 col-form-label app-label">Refresh Token:</label>
                <div class="col-sm-7 col-xs-12 inpt_bx">
                    <span class="view_app_info app-field-lbl">
                        {this.state.andr_refresh_token}
                    </span>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="tvapp" class="col-sm-5 col-form-label app-label">Force Update For Version:</label>
            <div class="col-sm-6 col-xs-12 app-field-lbl">
                <span>{this.state.andr_force_update_version} </span>    
            </div>
        </div>
    </div>
</div>
                )
        }
        getEditAndroidInfo(){
        return(
<div class="row">
    <div class="col-md-12 app_tv_form">
        <div class="form-group row">
            <label for="tvapp" class="col-sm-5 col-form-label app-label">FCM Key:</label>
            <div class="col-sm-6 col-xs-12">
                <input type="text" id="fcm_key" name="andr_fcm_key" class="form-control per_new_fields app-field-lbl" placeholder="Enter FCM Key" value={this.state.andr_fcm_key} onChange={this.onChangeaction.bind(this, 'andr_fcm_key')}/>
            </div>
        </div>
        <div class="form-group row">
            <label for="tvapp" class="col-sm-5 col-form-label app-label">Deeplink Code:</label>
            <div class="col-sm-6 col-xs-12">
                <textarea id="deep_link" name="andr_deep_link_code" class="form-control per_new_fields app-field-lbl" placeholder="Enter Deeplinking Code" value={this.state.andr_deep_link_code} onChange={this.onChangeaction.bind(this, 'andr_deep_link_code')}></textarea>
            </div>
        </div>
        <span class="job_title shared_secret app-label">In-app Credentials:</span>
        <div class="secret_ky">
            <div class="form-group row">
                <label for="tvapp" class="col-sm-4 col-form-label app-label">Client ID:</label>
                <div class="col-sm-7 col-xs-12 inpt_bx">
                    <input type="text" id="sandbox_key" name="andr_client_id" class="form-control per_new_fields app-field-lbl" placeholder="Enter Client ID" value={this.state.andr_client_id} onChange={this.onChangeaction.bind(this, 'andr_client_id')}/>
                </div>
            </div>
            <div class="form-group row">
                <label for="tvapp" class="col-sm-4 col-form-label app-label">Client Secret:</label>
                <div class="col-sm-7 col-xs-12 inpt_bx">
                    <input type="text" id="production_key" name="andr_client_secret" class="form-control per_new_fields app-field-lbl" placeholder="Enter Client Secret" value={this.state.andr_client_secret} onChange={this.onChangeaction.bind(this, 'andr_client_secret')}/>
                </div>
            </div>
            <div class="form-group row">
                <label for="tvapp" class="col-sm-4 col-form-label app-label">Refresh Token:</label>
                <div class="col-sm-7 col-xs-12 inpt_bx">
                    <input type="text" id="andr_refresh_token" name="andr_refresh_token" class="form-control per_new_fields app-field-lbl" placeholder="Enter Refresh Token" value={this.state.andr_refresh_token} onChange={this.onChangeaction.bind(this, 'andr_refresh_token')}/>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="tvapp" class="col-sm-5 col-form-label app-label">Force Update For Version:</label>
            <div class="col-sm-6 col-xs-12">
                <input type="text" id="andr_code" name="andr_force_update_version" class="form-control per_new_fields force_update_version app-field-lbl"  placeholder="Enter Version Code" value={this.state.andr_force_update_version} onChange={this.onChangeaction.bind(this, 'andr_force_update_version')} onKeyUp={this.handleKeyUp}/>
            </div>
        </div>
    </div>
    <span class="app_update" id="android_update" ><a a href="javascript:void(0);" id ="android_form_update" class="btn btn-trans Medium" onClick={() => this.updateAppSettings()}> Update</a></span>
</div>
                )
        }
        getViewiosInfo(){
        return(
<div class="row">
    <span class="emps_edit conf_edit"><a href="javascript:void(0);" class="btn btn-trans Medium" onClick={this.ios_edit.bind(this)}> <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit</a></span>
    <div class="col-md-12 app_tv_form">
        <div class="form-group row">
            <label for="ios" class="col-sm-5 col-form-label app-label">FCM Key:</label>
            <div class="col-sm-6 col-xs-12">
                <span class="view_app_info app-field-lbl">{this.state.ios_fcm_key}</span>
            </div>
        </div>
        <div class="form-group row">
            <label for="ios" class="col-sm-5 col-form-label app-label">Deeplink Code:</label>
            <div class="col-sm-6 col-xs-12">
                <span class="view_app_info app-field-lbl">{this.state.ios_deep_link_code}</span>
            </div>
        </div>
        <span class="job_title shared_secret app-label">Shared Secret Key:</span>
        <div class="secret_ky">
            <div class="form-group row">
                <label for="ios" class="col-sm-4 col-form-label app-label">Key:</label>
                <div class="col-sm-7 col-xs-12 inpt_bx">
                    <span class="view_app_info app-field-lbl">{this.state.ios_secret_code}</span>
                </div>
            </div>
            <div class="form-group row">
                <label for="ios" class="col-sm-4 col-form-label app-label">Mode:</label>
                <div class="col-sm-6 col-xs-12 radio_custom">
                    <div class="radio_custom per_new_fields">
                        <span class="view_mode app-field-lbl">
                            {this.state.ios_mode == 'sandbox' ? 'Sandbox' : (this.state.ios_mode == 'production' ? 'Production' : '')}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="ios" class="col-sm-5 col-form-label app-label">Force Update For Version:</label>
            <div class="col-sm-6 col-xs-12">
                <span class="app-field-lbl">{this.state.ios_force_update_version}</span>
            </div>
        </div>
    </div>
</div>
                )
        }
        getEditiosInfo(){
        return(
<div class="row">
    <div class="col-md-12 app_tv_form">
        <div class="form-group row">
            <label for="ios" class="col-sm-5 col-form-label app-label">FCM Key:</label>
            <div class="col-sm-6 col-xs-12">
                <input type="text" id="fcm_key" name="ios_fcm_key" class="form-control per_new_fields app-field-lbl" placeholder="Enter FCM Key" value={this.state.ios_fcm_key} onChange={this.onChangeaction.bind(this, 'ios_fcm_key')}/>
            </div>
        </div>
        <div class="form-group row">
            <label for="ios" class="col-sm-5 col-form-label app-label">Deeplink Code:</label>
            <div class="col-sm-6 col-xs-12">
                <textarea id="deep_link" name="ios_deep_link_code" class="form-control per_new_fields app-field-lbl" placeholder="Enter Deeplinking Code" value={this.state.ios_deep_link_code} onChange={this.onChangeaction.bind(this, 'ios_deep_link_code')}></textarea>
            </div>
        </div>
        <span class="job_title shared_secret app-label">Shared Secret Key:</span>
        <div class="secret_ky">
            <div class="form-group row">
                <label for="ios" class="col-sm-4 col-form-label app-label">Key:</label>
                <div class="col-sm-7 col-xs-12 inpt_bx">
                    <input type="text" id="key" name="ios_secret_code" class="form-control per_new_fields app-field-lbl" placeholder="Enter Key" value={this.state.ios_secret_code} onChange={this.onChangeaction.bind(this, 'ios_secret_code')}/>
                </div>
            </div>
            <div class="form-group row">
                <label for="ios" class="col-sm-4 col-form-label app-label">Mode:</label>
                <div class="col-sm-6 col-xs-12 radio_custom">
                    <div class="radio_custom per_new_fields">
                        <div class="radio-inline feature-check">
                            <input class="valid_fld app-field-lbl" id="ios_mode1" value="sandbox" type="radio" name="ios_mode"  onChange={this.onChangeaction.bind(this, 'ios_mode')} checked={this.state.ios_mode === 'sandbox'}/>
                            <label for="ios_mode1"><span></span>Sandbox</label>
                        </div>
                        <div class="radio-inline feature-check">
                            <input class="valid_fld app-field-lbl" id="ios_mode2" value="production" type="radio" name="ios_mode" onChange={this.onChangeaction.bind(this, 'ios_mode')} checked={this.state.ios_mode === 'production'} />
                            <label for="ios_mode2"><span></span>Production</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="ios" class="col-sm-5 col-form-label app-label">Force Update For Version:</label>
            <div class="col-sm-6 col-xs-12">
                <input type="text" id="ios_code" name="ios_force_update_version" class="force_update_version form-control per_new_fields app-field-lbl"  placeholder="Enter Version Code" value={this.state.ios_force_update_version} onChange={this.onChangeaction.bind(this, 'ios_force_update_version')} onKeyUp={this.handleKeyUp}/>
            </div>
        </div>
    </div>
    <span class="app_update" id="android_update" ><a a href="javascript:void(0);" id ="ios_form_update" class="btn btn-trans Medium" onClick={() => this.updateiosAppSettings()}> Update</a></span>
</div>
                )
        }
        getViewRokuInfo(){
        return(
<div class="row">
    <span class="emps_edit conf_edit"><a href="javascript:void(0);" class="btn btn-trans Medium" onClick={this.roku_edit.bind(this)}> <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit</a></span>
    <div class="col-md-12 app_tv_form">
        <span class="job_title shared_secret app-label ">Shared Secret Key:</span>
        <div class="secret_ky">
            <div class="form-group row">
                <label for="tvapp" class="col-sm-4 col-form-label app-label">Sandbox Key:</label>
                <div class="col-sm-7 col-xs-12 inpt_bx">
                    <span class="view_app_info app-field-lbl"> {this.state.roku_sandbox_key}</span>
                </div>
            </div>
            <div class="form-group row">
                <label for="tvapp" class="col-sm-4 col-form-label app-label">Production Key:</label>
                <div class="col-sm-7 col-xs-12 inpt_bx">
                    <span class="view_app_info app-field-lbl">{this.state.roku_production_key}</span>
                </div>
            </div>
            <div class="form-group row">
                <label for="tvapp" class="col-sm-4 col-form-label app-label">Mode:</label>
                <div class="col-sm-6 col-xs-12 radio_custom">
                    <div class="radio_custom per_new_fields">
                        <span class="view_mode app-field-lbl">
                            {this.state.roku_mode == 'sandbox' ? 'Sandbox' : (this.state.roku_mode == 'production' ? 'Production' : '')}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="roku" class="col-sm-5 col-form-label app-label">Force Update For Version:</label>
            <div class="col-sm-6 col-xs-12">
                <span class="app-field-lbl">{this.state.roku_force_update_version}</span>
            </div>
        </div>
    </div>
</div>
                )
        }
        getEditRokuInfo(){
        return(
<div class="row">
    <div class="col-md-12 app_tv_form">
        <span class="job_title shared_secret app-label">Shared Secret Key:</span>
        <div class="secret_ky">
            <div class="form-group row">
                <label for="tvapp" class="col-sm-4 col-form-label app-label">Sandbox Key:</label>
                <div class="col-sm-7 col-xs-12 inpt_bx">
                    <input type="text" id="sandbox_key" name="roku_sandbox_key" class="form-control per_new_fields app-field-lbl" placeholder="Enter Sandbox Key" value={this.state.roku_sandbox_key} onChange={this.onChangeaction.bind(this, 'roku_sandbox_key')}/>
                </div>
            </div>
            <div class="form-group row">
                <label for="tvapp" class="col-sm-4 col-form-label app-label">Production Key:</label>
                <div class="col-sm-7 col-xs-12 inpt_bx">
                    <input type="text" id="production_key" name="roku_production_key" class="form-control per_new_fields app-field-lbl" placeholder="Enter Production Key" value={this.state.roku_production_key} onChange={this.onChangeaction.bind(this, 'roku_production_key')}/>
                </div>
            </div>
            <div class="form-group row">
                <label for="tvapp" class="col-sm-4 col-form-label app-label">Mode:</label>
                <div class="col-sm-6 col-xs-12 radio_custom">
                    <div class="radio_custom per_new_fields">
                        <div class="radio-inline feature-check">
                            <input class="valid_fld app-field-lbl" id="roku_mode1" value="sandbox" type="radio" name="roku_mode" onChange={this.onChangeaction.bind(this, 'roku_mode')} checked={this.state.roku_mode === 'sandbox'} />
                            <label for="roku_mode1"><span></span>Sandbox</label>
                        </div>
                        <div class="radio-inline feature-check">
                            <input class="valid_fld app-field-lbl" id="roku_mode2" value="production" type="radio" name="roku_mode" onChange={this.onChangeaction.bind(this, 'roku_mode')} checked={this.state.roku_mode === 'production'} />
                            <label for="roku_mode2"><span></span>Production</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="roku" class="col-sm-5 col-form-label app-label">Force Update For Version:</label>
            <div class="col-sm-6 col-xs-12">
                <input type="text" id="roku_code" name="roku_force_update_version" class="force_update_version form-control per_new_fields app-field-lbl"  placeholder="Enter Version Code" value={this.state.roku_force_update_version} onChange={this.onChangeaction.bind(this, 'roku_force_update_version')} onKeyUp={this.handleKeyUp}/>
            </div>
        </div>
    </div>
    <span class="app_update" id="roku_update" ><a a href="javascript:void(0);" id ="roku_form_update" class="btn btn-trans Medium" onClick={() => this.updateRokuAppSettings()} > Update</a></span>
</div>
                )
        }

    getRecentBandwidth(){
        return  (<div><div class="single-box">
                                    <div class="icon-box">
                                        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <mask id="mask0_148_2961" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="14">
                                                <path d="M8.03 0.999994C4.14733 0.999994 1 4.14733 1 8.02999C1 9.86834 1.60212 11.6982 2.7575 12.951H13.3025C14.4575 11.6982 15.06 9.86834 15.06 8.02999C15.06 4.14733 11.9127 0.999994 8.03 0.999994Z" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path d="M8.03002 10.4905C8.80654 10.4905 9.43602 9.86101 9.43602 9.0845C9.43602 8.30799 8.80654 7.6785 8.03002 7.6785C7.25351 7.6785 6.62402 8.30799 6.62402 9.0845C6.62402 9.86101 7.25351 10.4905 8.03002 10.4905Z" fill="white" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path d="M8.02982 5.5695V7.6785M8.02982 2.7575V3.4605M2.75732 8.3815H3.46032M4.16332 4.8665L4.66035 5.36352M12.5993 8.3815H13.3023M11.5448 5.36352L12.0418 4.8665" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            </mask>
                                            <g mask="url(#mask0_148_2961)">
                                                <path d="M-0.679688 -1.46051H16.5438V15.4115H-0.679688V-1.46051Z" fill="#52B7ED"></path>
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="name">Bandwidth Used In This Month</div>
                                        <div class="desc">{this.state.get_bandwidth_api == 1 ? this.state.bandwidth : 'NA'}</div>
                                    </div>
                                </div>
                                </div>
                                        )  
    }
    
    formatBytes(bytes) {
        if (!+bytes) return '0.00 B';
        var size = 'GB';
        return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} ${size}`
    }
    
    getBandwidthDetails(){
    var studioId = this.props.match.params.studioId;
    const firstdate = moment().startOf('month').format('YYYY-MM-DD');
    fetch('https://analytics.muvi.com/data/getbySQL/', {
            method: 'POST',
            dataType: 'json',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: `select sum(total_buffer_size) as total_bandwidth from muvi_totalbandwidth_live where store_key = '`+studioId+`' and created_date >= '`+firstdate+`'`
            })
        }).then((Response) => Response.json())
                .then((findresponse) => {
                   if (findresponse.code == 200) {
                       var total_bandwidth = this.formatBytes(findresponse.result[0].total_bandwidth);
                            this.setState({
                                bandwidth: total_bandwidth,
                                get_bandwidth_api:1
                            })
                        }
                })
    }    
                                                
        componentDidMount()
        {
        this.getCustomerDetails();
        this.otherBillingDetails();
        this.customerDeepLinking();
                this.showLoginDetails();
                this.showUploadDetails();
                document.title = "Intranet | Customer Details";
        if(!localStorage.getItem('userLogin')){     
        this.setState({redirect:true});
        }
        }
        
        render() {
        if(this.state.redirect) {
        return (
<Redirect to={'/login'} />
                )
        }
        return (
<div >
    <Header brecum_name="Customer" brecum_page="Customers Details"/>
    <div className="right_col">
        <div class="title mob hidden-md">
            <HeaderMob page_name="Customer Details"/>
        </div>
        <section class="store-section">
                <div class="customer-details-area container" id="exTab1" >
                <ul class="nav nav-pills">
                    <li class="active">
                                <a  href="#CustomersInfo" data-toggle="tab">General Info</a>
                    </li>
                            <li><a href="#AppInfo" data-toggle="tab">App Info</a>
                            </li>
                    <li><a href="#Login" data-toggle="tab">Login</a>
                    </li>
                    <li><a href="#Upload" data-toggle="tab">Upload</a>
                    </li>
                </ul>
                        {this.state.loader == 1 ?
                        <ContentLoader/>
                        :
                <div class="tab-content customer-tab clearfix">
                    <div class="tab-pane active" id="CustomersInfo">
                <div class="top-area">
                    <div class="profile-area">
                        <div class="profile-left">
                            <div class="img-box">
                            <img src={this.state.data.logo} alt='Logo' class='store-logo'/>
                            </div>
                            <div class="text-area">
                                <div class="name cap-text">{this.state.data.name ? this.state.data.name : 'NA'}</div>
                                <div class="email">{this.state.data.domain && this.state.data.domain != 'NA' ? <Link to={`http://${this.state.data.domain}`} name={"max"} target="_blank"> {this.state.data.domain} </Link> : ''}</div>
                            </div>
                        </div>
                    </div>
                    <div class="contact-information-area">
                        <div class="store-title">Contact Information</div>
                                <div class="row">
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2 6.00001L8 1.33334L14 6.00001V13.3333C14 13.687 13.8595 14.0261 13.6095 14.2762C13.3594 14.5262 13.0203 14.6667 12.6667 14.6667H3.33333C2.97971 14.6667 2.64057 14.5262 2.39052 14.2762C2.14048 14.0261 2 13.687 2 13.3333V6.00001Z" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M6 14.6667V8H10V14.6667" fill="#52B7ED"></path>
                                            <path d="M6 14.6667V8H10V14.6667" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                        </div>
                                    <div class="only-text">
                                        <div class="top-text">Company Name</div>
                                        <div class="bottom-text cap-text">{this.state.data.name ? this.state.data.name : 'NA'}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.9997 14V12.6667C13.9997 11.9594 13.7187 11.2811 13.2186 10.781C12.7185 10.281 12.0403 10 11.333 10H5.99967C5.29243 10 4.61415 10.281 4.11406 10.781C3.61396 11.2811 3.33301 11.9594 3.33301 12.6667V14" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M8.66667 7.33333C10.1394 7.33333 11.3333 6.13943 11.3333 4.66667C11.3333 3.19391 10.1394 2 8.66667 2C7.19391 2 6 3.19391 6 4.66667C6 6.13943 7.19391 7.33333 8.66667 7.33333Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="top-text">User Name</div>
                                        <div class="bottom-text cap-text">{this.state.data.first_name} {this.state.data.last_name}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.00033 2.66666H13.667C14.4003 2.66666 15.0003 3.26666 15.0003 3.99999V12C15.0003 12.7333 14.4003 13.3333 13.667 13.3333H3.00033C2.26699 13.3333 1.66699 12.7333 1.66699 12V3.99999C1.66699 3.26666 2.26699 2.66666 3.00033 2.66666Z" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M15.0003 4L8.33366 8.66667L1.66699 4" fill="#52B7ED"></path>
                                            <path d="M1.66699 4L8.33366 8.66667L15.0003 4H1.66699ZM1.66699 4L3.00037 3" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="top-text">Email ID</div>
                                        <div class="bottom-text">{this.state.data.email ? this.state.data.email : "NA"}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.0089 4.47514C10.6135 4.59306 11.1691 4.88865 11.6047 5.32407C12.0403 5.7595 12.336 6.31495 12.454 6.91934M10.0089 2C11.265 2.1395 12.4364 2.70181 13.3306 3.59461C14.2249 4.48742 14.7889 5.65764 14.93 6.91315M14.311 11.8511V13.7074C14.3117 13.8797 14.2764 14.0503 14.2073 14.2082C14.1382 14.3661 14.037 14.5079 13.9099 14.6244C13.7829 14.7409 13.6329 14.8296 13.4696 14.8848C13.3063 14.94 13.1332 14.9605 12.9615 14.945C11.0567 14.7381 9.22704 14.0874 7.61947 13.0453C6.12383 12.0953 4.85578 10.8277 3.90539 9.3326C2.85925 7.71832 2.20821 5.8804 2.00502 3.96774C1.98956 3.79662 2.0099 3.62416 2.06476 3.46134C2.11962 3.29851 2.20779 3.14889 2.32367 3.022C2.43955 2.8951 2.58058 2.79372 2.73781 2.7243C2.89503 2.65488 3.06498 2.61895 3.23686 2.61878H5.0939C5.39431 2.61583 5.68554 2.72217 5.91332 2.91799C6.1411 3.1138 6.28987 3.38574 6.33192 3.68309C6.4103 4.27717 6.55566 4.86047 6.76523 5.42188C6.84851 5.64336 6.86654 5.88406 6.81717 6.11546C6.7678 6.34687 6.6531 6.55927 6.48667 6.72752L5.70053 7.51337C6.58173 9.06253 7.86488 10.3452 9.4146 11.2261L10.2007 10.4402C10.369 10.2739 10.5815 10.1592 10.813 10.1099C11.0445 10.0605 11.2853 10.0785 11.5069 10.1618C12.0685 10.3713 12.652 10.5166 13.2463 10.5949C13.547 10.6373 13.8216 10.7887 14.0179 11.0203C14.2142 11.2519 14.3185 11.5476 14.311 11.8511Z" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="top-text">Contact Number</div>
                                        <div class="bottom-text">{this.state.data.phone ? this.state.data.phone : "NA"}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.6665 6.66667C14.6665 11.3333 8.6665 15.3333 8.6665 15.3333C8.6665 15.3333 2.6665 11.3333 2.6665 6.66667C2.6665 5.07537 3.29864 3.54925 4.42386 2.42403C5.54908 1.29881 7.07521 0.666672 8.6665 0.666672C10.2578 0.666672 11.7839 1.29881 12.9091 2.42403C14.0344 3.54925 14.6665 5.07537 14.6665 6.66667Z" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M8.6665 8.66667C9.77107 8.66667 10.6665 7.77124 10.6665 6.66667C10.6665 5.5621 9.77107 4.66667 8.6665 4.66667C7.56193 4.66667 6.6665 5.5621 6.6665 6.66667C6.6665 7.77124 7.56193 8.66667 8.6665 8.66667Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="top-text">Address</div>
                                        <div class="bottom-text cap-text">{this.state.data.signup_location ? this.state.data.signup_location : "NA"}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.0002 2.66667H3.66683C2.93045 2.66667 2.3335 3.26363 2.3335 4.00001V13.3333C2.3335 14.0697 2.93045 14.6667 3.66683 14.6667H13.0002C13.7365 14.6667 14.3335 14.0697 14.3335 13.3333V4.00001C14.3335 3.26363 13.7365 2.66667 13.0002 2.66667Z" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M11 1.33333V3.99999" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M5.66699 1.33333V3.99999" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M14.3334 6.66666H2.33339C2.2223 5.44444 2.50014 3.89999 4.50014 3.49999C6.50014 3.09999 10.6668 3.33332 12.5001 3.49999L13.5001 3.5L14.3334 6.66666Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="top-text">Account Manager</div>
                                        <div class="bottom-text cap-text">{this.state.account_manager ? <Link to={`/viewEmployee/${this.state.account_manager.id}`} name={"max"} target="_blank"> {this.state.account_manager.name} </Link> : 'NA'}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom-area">
                                        <div class="row">
                        <div class="col-md-8 padding-right">
                            <div class="product-area">
                                <div class="store-title">Product</div>
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Customer Type</div>
                                            <div class="bottom-text cap-text">{this.state.data.customer_type ? this.state.data.customer_type : 'NA'}</div>
                                                </div>
                                                </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Product</div>
                                            <div class="bottom-text">Muvi One (Classic)</div>
                                            </div>
                                            </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Joined On</div>
                                            <div class="bottom-text">{this.state.data.created_at ? new Date(this.state.data.created_at).toLocaleDateString("en-US", {month:"short", day:"numeric", year:"numeric" }) : 'NA'}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Product Plan</div>
                                            <div class="bottom-text cap-text">{this.state.data.package ? this.state.data.package.name : 'NA'}</div>
                                    </div>
                                </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Product Pricing</div>
                                            {this.state.data.package ?
                                            this.state.data.package.name == 'Muvi Standard' ?
                                            <div class="bottom-text">{this.state.data.package?(this.state.data.is_old && this.state.data.package.is_old_base_price ? '$ '+this.state.data.base_price : '$ '+this.state.data.package.base_price):'NA'}</div>
                                            :
                                            <div class="bottom-text">{this.state.data.package?(this.state.data.is_old != '0' && this.state.data.is_old != 0 && this.state.data.package.is_old_base_price != '0' && this.state.data.package.is_old_base_price != 0 ? '$ '+this.state.data.base_price : '$ '+this.state.data.package.base_price):'NA'}</div>
                                            :
                                            <div class="bottom-text">NA</div>        
                                            }
                            </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Plan Term</div>
                                            <div class="bottom-text">{this.state.data.sel_plan ? this.state.data.sel_plan : 'NA'}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Source</div>
                                            <div class="bottom-text">{this.state.data.source ? <Link to={`${this.state.data.source}`} name={"max"} target="_blank"> {this.state.data.source} </Link> : "NA"}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Applications</div>
                                            <div class="bottom-text">
                                            {this.state.applications.length > 0 ? this.state.applications.map((data,key)=> 
                                              <span> {data.name}{key !== this.state.applications.length - 1 ? ', ' : ''}</span>
                                            ) : 'NA'}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Free Trial Expires On</div>
                                            <div class="bottom-text">NA</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="product-area revenue-area">
                                <div class="store-title">Revenue &amp; Billing</div>
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Last Paid Amount</div>
                                            <div class="bottom-text">{this.state.data.paid_amount ? '$ '+this.state.data.paid_amount : 'NA'}</div>
                                    </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Mode of payment</div>
                                            <div class="bottom-text">{this.state.payment_method ? this.state.payment_method : 'NA'}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Subscription Started On</div>
                                            <div class="bottom-text">{this.state.data.subscription_start ? new Date(this.state.data.subscription_start).toLocaleDateString("en-US", {month:"short", day:"numeric", year:"numeric" }) : 'NA'}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Revenue Last 30Days</div>
                                            <div class="bottom-text">{this.state.revenue_last_month ? '$ '+this.state.revenue_last_month : 'NA'}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Revenue Lifetime</div>
                                            <div class="bottom-text">NA</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Last Transaction Date</div>
                                            <div class="bottom-text">{this.state.data.created_date && this.state.data.created_date != '' && this.state.data.created_date != '00-00-00 00:00:00' ?  new Date(this.state.data.created_date).toLocaleDateString("en-US", {month:"short", day:"numeric", year:"numeric" }) : 'NA'}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Next Subscription Billing Date</div>
                                            <div class="bottom-text">{this.state.data.start_date && this.state.data.start_date != '' && this.state.data.start_date != '00-00-00 00:00:00' ? new Date(this.state.data.start_date).toLocaleDateString("en-US", {month:"short", day:"numeric", year:"numeric" }) : this.state.data.end_date && this.state.data.end_date != '' && this.state.data.end_date != '00-00-00 00:00:00' ? new Date(this.state.data.end_date).toLocaleDateString("en-US", {month:"short", day:"numeric", year:"numeric" }) : 'N/A'}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Next Infra Billing Date</div>
                                            <div class="bottom-text">NA</div>
                                        </div>
                                    </div>
                                        </div>
                                    </div>
                            {this.state.cards_list && this.state.cards_list != '' ? 
                            <div class="cards-details-area">
                                <div class="store-title">Card Details</div>
                                        <div class="row">
                               {this.state.cards_list.map((data, key) =>
                                <div class="col-md-6">
                                <div>
                                <div class="card-desc card-datas">{data.card_type ? data.card_type : 'NA'}</div>
                                {data.is_cancelled == 1 ? <div class="badge">Primary Card</div> : ''} 
                                                    </div>
                                <div class="single-card">
                                    <div class="icon-area">
                                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_148_3354)">
                                                <path d="M31.5 6.75C32.0967 6.75 32.669 6.98705 33.091 7.40901C33.5129 7.83097 33.75 8.40326 33.75 9V27C33.75 27.5967 33.5129 28.169 33.091 28.591C32.669 29.0129 32.0967 29.25 31.5 29.25H4.5C3.90326 29.25 3.33097 29.0129 2.90901 28.591C2.48705 28.169 2.25 27.5967 2.25 27V9C2.25 8.40326 2.48705 7.83097 2.90901 7.40901C3.33097 6.98705 3.90326 6.75 4.5 6.75H31.5ZM4.5 4.5C3.30653 4.5 2.16193 4.97411 1.31802 5.81802C0.474106 6.66193 0 7.80653 0 9L0 27C0 28.1935 0.474106 29.3381 1.31802 30.182C2.16193 31.0259 3.30653 31.5 4.5 31.5H31.5C32.6935 31.5 33.8381 31.0259 34.682 30.182C35.5259 29.3381 36 28.1935 36 27V9C36 7.80653 35.5259 6.66193 34.682 5.81802C33.8381 4.97411 32.6935 4.5 31.5 4.5H4.5Z" fill="#52B7ED"></path>
                                                <path d="M4.5 12.375C4.5 12.0766 4.61853 11.7905 4.82951 11.5795C5.04048 11.3685 5.32663 11.25 5.625 11.25H10.125C10.4234 11.25 10.7095 11.3685 10.9205 11.5795C11.1315 11.7905 11.25 12.0766 11.25 12.375V14.625C11.25 14.9234 11.1315 15.2095 10.9205 15.4205C10.7095 15.6315 10.4234 15.75 10.125 15.75H5.625C5.32663 15.75 5.04048 15.6315 4.82951 15.4205C4.61853 15.2095 4.5 14.9234 4.5 14.625V12.375ZM4.5 19.125C4.5 18.8266 4.61853 18.5405 4.82951 18.3295C5.04048 18.1185 5.32663 18 5.625 18H16.875C17.1734 18 17.4595 18.1185 17.6705 18.3295C17.8815 18.5405 18 18.8266 18 19.125C18 19.4234 17.8815 19.7095 17.6705 19.9205C17.4595 20.1315 17.1734 20.25 16.875 20.25H5.625C5.32663 20.25 5.04048 20.1315 4.82951 19.9205C4.61853 19.7095 4.5 19.4234 4.5 19.125ZM4.5 23.625C4.5 23.3266 4.61853 23.0405 4.82951 22.8295C5.04048 22.6185 5.32663 22.5 5.625 22.5H7.875C8.17337 22.5 8.45952 22.6185 8.6705 22.8295C8.88147 23.0405 9 23.3266 9 23.625C9 23.9234 8.88147 24.2095 8.6705 24.4205C8.45952 24.6315 8.17337 24.75 7.875 24.75H5.625C5.32663 24.75 5.04048 24.6315 4.82951 24.4205C4.61853 24.2095 4.5 23.9234 4.5 23.625ZM11.25 23.625C11.25 23.3266 11.3685 23.0405 11.5795 22.8295C11.7905 22.6185 12.0766 22.5 12.375 22.5H14.625C14.9234 22.5 15.2095 22.6185 15.4205 22.8295C15.6315 23.0405 15.75 23.3266 15.75 23.625C15.75 23.9234 15.6315 24.2095 15.4205 24.4205C15.2095 24.6315 14.9234 24.75 14.625 24.75H12.375C12.0766 24.75 11.7905 24.6315 11.5795 24.4205C11.3685 24.2095 11.25 23.9234 11.25 23.625ZM18 23.625C18 23.3266 18.1185 23.0405 18.3295 22.8295C18.5405 22.6185 18.8266 22.5 19.125 22.5H21.375C21.6734 22.5 21.9595 22.6185 22.1705 22.8295C22.3815 23.0405 22.5 23.3266 22.5 23.625C22.5 23.9234 22.3815 24.2095 22.1705 24.4205C21.9595 24.6315 21.6734 24.75 21.375 24.75H19.125C18.8266 24.75 18.5405 24.6315 18.3295 24.4205C18.1185 24.2095 18 23.9234 18 23.625ZM24.75 23.625C24.75 23.3266 24.8685 23.0405 25.0795 22.8295C25.2905 22.6185 25.5766 22.5 25.875 22.5H28.125C28.4234 22.5 28.7095 22.6185 28.9205 22.8295C29.1315 23.0405 29.25 23.3266 29.25 23.625C29.25 23.9234 29.1315 24.2095 28.9205 24.4205C28.7095 24.6315 28.4234 24.75 28.125 24.75H25.875C25.5766 24.75 25.2905 24.6315 25.0795 24.4205C24.8685 24.2095 24.75 23.9234 24.75 23.625Z" fill="#52B7ED"></path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_148_3354">
                                                    <rect width="36" height="36" fill="white"></rect>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                                </div>
                                    <div class="only-text">
                                        <div class="number">{data.card_last_fourdigit ? data.card_last_fourdigit : 'NA'}</div>
                                        <div class="name cap-text card-holder-name">{data.card_holder_name ? data.card_holder_name : 'NA'}</div>
                                            </div>
                                </div>
                                </div>
                                )}
                                                    </div>
                                                </div>
                            :''}
                            <div class="product-area account-area">
                                <div class="store-title">Account</div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Cancelled By</div>
                                            <div class="bottom-text">{this.state.data.cancelled_by ? this.state.data.cancelled_by : 'NA'}</div>
                                            </div>
                                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Cancellation Reason</div>
                                            <div class="bottom-text">{this.state.data.reason ? this.state.data.reason : 'NA'}</div>
                                                </div>
                                            </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">On hold Period</div>
                                            <div class="bottom-text">{this.state.data.start_date_change ? new Date(this.state.data.start_date_change).toLocaleDateString("en-US", {month:"short", day:"numeric", year:"numeric" }) + ' - ' + new Date(this.state.data.end_date_change).toLocaleDateString("en-US",{month:"short", day:"numeric", year:"numeric" }) : 'NA'}</div>
                                                    </div>
                                                </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Cancellation Date</div>
                                            <div class="bottom-text">{this.state.data.start_date_change && this.state.data.start_date_change != '' && this.state.data.start_date_change != '00-00-00 00:00:00' ? new Date(this.state.data.start_date_change).toLocaleDateString("en-US", {month:"short", day:"numeric", year:"numeric" }) : 'NA'}</div>
                                            </div>
                                        </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Deleted by</div>
                                            <div class="bottom-text">NA</div>
                                    </div>
                                </div>
                                     <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Deletion Date</div>
                                            <div class="bottom-text">{this.state.data.deleted_date ?  new Date(this.state.data.deleted_date).toLocaleDateString("en-US", {month:"short", day:"numeric", year:"numeric" }) : 'NA'}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                        <div class="single-product">
                                            <div class="top-text">Blocked</div>
                                            <div class="bottom-text">{this.state.data.is_blocked == 1 ? 'Yes' : 'No'}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 padding-left">
                            <div class="analytics-area">
                                <div class="store-title">Analytics</div>
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_148_2952)">
                                                <path d="M14.1399 10.5933C13.7158 11.5963 13.0525 12.4801 12.2079 13.1675C11.3633 13.8549 10.3631 14.3249 9.2949 14.5365C8.22668 14.7481 7.12289 14.6948 6.08004 14.3812C5.03719 14.0676 4.08703 13.5034 3.31262 12.7378C2.53822 11.9722 1.96315 11.0285 1.6377 9.9893C1.31225 8.9501 1.24632 7.84699 1.44568 6.77642C1.64503 5.70585 2.10361 4.70042 2.78131 3.84802C3.45901 2.99562 4.3352 2.32221 5.33328 1.88667" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path d="M14.6667 8C14.6667 7.12452 14.4942 6.25762 14.1592 5.44878C13.8242 4.63994 13.3331 3.90501 12.714 3.28596C12.095 2.6669 11.3601 2.17584 10.5512 1.84081C9.74239 1.50577 8.87548 1.33334 8 1.33334V8H14.6667Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_148_2952">
                                                    <rect width="16" height="16" fill="white"></rect>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="name">Storage</div>
                                        <div class="desc">{this.state.storage ? this.state.storage : '0.00 B'}</div>
                                    </div>
                                </div>
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_148_2996)">
                                                <path d="M7.99231 14.5428C8.08462 15.0846 8.27692 15.5887 8.54615 16.0476H2.53846C1.68462 16.0476 1 15.378 1 14.5428V2.50475C1 2.10566 1.16209 1.72292 1.4506 1.44072C1.73912 1.15852 2.13044 0.999985 2.53846 0.999985H8.69231L13.3077 5.51427V9.34389C13.0538 9.30627 12.8 9.27618 12.5385 9.27618C12.2769 9.27618 12.0231 9.30627 11.7692 9.34389V6.26665H7.92308V2.50475H2.53846V14.5428H7.99231ZM11 10.7809L9.07692 13.0381H10.2308V16.0476H11.7692V13.0381H12.9231L11 10.7809ZM14.8462 14.5428V11.5333H13.3077V14.5428H12.1538L14.0769 16.8L16 14.5428H14.8462Z" fill="#52B7ED"></path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_148_2996">
                                                    <rect width="16" height="16" fill="white" transform="translate(0 0.673462)"></rect>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="name">Total Content Uploaded</div>
                                        <div class="desc">{this.state.count ? this.state.count : 'NA'}</div>
                                    </div>
                                </div>
                                {this.getRecentBandwidth()}
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 2.67347H12.6667C13.0203 2.67347 13.3594 2.81395 13.6095 3.06399C13.8595 3.31404 14 3.65318 14 4.0068V13.3401C14 13.6938 13.8595 14.0329 13.6095 14.2829C13.3594 14.533 13.0203 14.6735 12.6667 14.6735H10" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M6.6665 12.0068L9.99984 8.67347L6.6665 5.34014" stroke="#52B7ED" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M10 8.67347H2" stroke="#52B7ED" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="name">Count of Login</div>
                                        <div class="desc">{this.state.data.total_login ? this.state.data.total_login : 'NA'}</div>
                                    </div>
                                </div>
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.7189 11.4992V10.4055C12.7189 9.82544 12.4885 9.26909 12.0783 8.85889C11.6681 8.44869 11.1117 8.21825 10.5316 8.21825H6.15702C5.57692 8.21825 5.02057 8.44869 4.61037 8.85889C4.20017 9.26909 3.96973 9.82544 3.96973 10.4055V11.4992" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M8.34452 6.03095C9.55253 6.03095 10.5318 5.05166 10.5318 3.84365C10.5318 2.63564 9.55253 1.65636 8.34452 1.65636C7.13651 1.65636 6.15723 2.63564 6.15723 3.84365C6.15723 5.05166 7.13651 6.03095 8.34452 6.03095Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M15.9998 11.4992V10.4055C15.9995 9.92091 15.8382 9.45012 15.5413 9.06709C15.2443 8.68407 14.8286 8.4105 14.3594 8.28934" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M2.2707 8.26145L1.49697 9.03437C1.15435 9.37713 0.93528 9.82398 0.874142 10.3047C0.813003 10.7855 0.913263 11.273 1.15918 11.6906" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M12.1724 1.72745C12.6429 1.84791 13.0599 2.12154 13.3577 2.5052C13.6555 2.88886 13.8171 3.36072 13.8171 3.84639C13.8171 4.33206 13.6555 4.80392 13.3577 5.18758C13.0599 5.57124 12.6429 5.84487 12.1724 5.96534" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M4.0957 5.97628C3.63047 5.83687 3.22487 5.54658 2.94284 5.15118C2.66081 4.75578 2.51841 4.27777 2.53807 3.79249C2.55773 3.30722 2.73834 2.84229 3.05143 2.471C3.36451 2.09971 3.79227 1.84319 4.26726 1.74187" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="name">Number of EndUsers</div>
                                        <div class="desc">{this.state.enduser_count ? this.state.enduser_count : 0}</div>
                                    </div>
                                </div>
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.3332 14.6735V13.3401C11.3332 12.6329 11.0522 11.9546 10.5521 11.4545C10.052 10.9544 9.37375 10.6735 8.6665 10.6735H3.33317C2.62593 10.6735 1.94765 10.9544 1.44755 11.4545C0.947456 11.9546 0.666504 12.6329 0.666504 13.3401V14.6735" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M6.00016 8.00679C7.47292 8.00679 8.66683 6.81289 8.66683 5.34013C8.66683 3.86737 7.47292 2.67346 6.00016 2.67346C4.5274 2.67346 3.3335 3.86737 3.3335 5.34013C3.3335 6.81289 4.5274 8.00679 6.00016 8.00679Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M15.3335 14.6735V13.3401C15.3331 12.7493 15.1364 12.1753 14.7744 11.7083C14.4124 11.2414 13.9056 10.9078 13.3335 10.7601" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M10.6665 2.76013C11.2401 2.907 11.7485 3.2406 12.1116 3.70834C12.4747 4.17608 12.6717 4.75135 12.6717 5.34347C12.6717 5.93558 12.4747 6.51085 12.1116 6.97859C11.7485 7.44633 11.2401 7.77993 10.6665 7.9268" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="name">Number of Subscribers</div>
                                        <div class="desc">{this.state.total_no_of_subscribed_users ? this.state.total_no_of_subscribed_users : 0}</div>
                                    </div>
                                </div>
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.7189 11.4992V10.4055C12.7189 9.82544 12.4885 9.26909 12.0783 8.85889C11.6681 8.44869 11.1117 8.21825 10.5316 8.21825H6.15702C5.57692 8.21825 5.02057 8.44869 4.61037 8.85889C4.20017 9.26909 3.96973 9.82544 3.96973 10.4055V11.4992" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M8.34452 6.03095C9.55253 6.03095 10.5318 5.05166 10.5318 3.84365C10.5318 2.63564 9.55253 1.65636 8.34452 1.65636C7.13651 1.65636 6.15723 2.63564 6.15723 3.84365C6.15723 5.05166 7.13651 6.03095 8.34452 6.03095Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M15.9998 11.4992V10.4055C15.9995 9.92091 15.8382 9.45012 15.5413 9.06709C15.2443 8.68407 14.8286 8.4105 14.3594 8.28934" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M2.2707 8.26145L1.49697 9.03437C1.15435 9.37713 0.93528 9.82398 0.874142 10.3047C0.813003 10.7855 0.913263 11.273 1.15918 11.6906" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M12.1724 1.72745C12.6429 1.84791 13.0599 2.12154 13.3577 2.5052C13.6555 2.88886 13.8171 3.36072 13.8171 3.84639C13.8171 4.33206 13.6555 4.80392 13.3577 5.18758C13.0599 5.57124 12.6429 5.84487 12.1724 5.96534" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M4.0957 5.97628C3.63047 5.83687 3.22487 5.54658 2.94284 5.15118C2.66081 4.75578 2.51841 4.27777 2.53807 3.79249C2.55773 3.30722 2.73834 2.84229 3.05143 2.471C3.36451 2.09971 3.79227 1.84319 4.26726 1.74187" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="name">Number of SubAdmin</div>
                                        <div class="desc">{this.state.subadmin_count ? this.state.subadmin_count : 0}</div>
                                    </div>
                                </div>
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.3735 14.0809H14.8302V3.21667C14.8302 3.0726 14.773 2.93444 14.6711 2.83256C14.5693 2.73069 14.4311 2.67346 14.287 2.67346H10.4846C10.3405 2.67346 10.2023 2.73069 10.1005 2.83256C9.99859 2.93444 9.94136 3.0726 9.94136 3.21667V5.93272H6.6821C6.53803 5.93272 6.39986 5.98995 6.29799 6.09182C6.19612 6.1937 6.13889 6.33186 6.13889 6.47593V9.19198H2.87963C2.73556 9.19198 2.59739 9.24921 2.49552 9.35108C2.39365 9.45295 2.33642 9.59112 2.33642 9.73519V14.0809H1.79321C1.64914 14.0809 1.51097 14.1381 1.4091 14.24C1.30723 14.3418 1.25 14.48 1.25 14.6241C1.25 14.7681 1.30723 14.9063 1.4091 15.0082C1.51097 15.1101 1.64914 15.1673 1.79321 15.1673H15.3735C15.5175 15.1673 15.6557 15.1101 15.7576 15.0082C15.8594 14.9063 15.9167 14.7681 15.9167 14.6241C15.9167 14.48 15.8594 14.3418 15.7576 14.24C15.6557 14.1381 15.5175 14.0809 15.3735 14.0809ZM7.22531 7.01914H9.94136V14.0809H7.22531V7.01914ZM3.42284 10.2784H6.13889V14.0809H3.42284V10.2784Z" fill="#52B7ED"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="name">Customer Revenue</div>
                                        <div class="desc">{this.state.currency.length > 0 ? this.getRevenue() : 0}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                <div class="tab-pane" id="AppInfo">
                <div class="customer-details-info-tabs">
                <div class="customer_product_addressI col-md-6 col-sm-6 col-xs-6 word-break">
                                                        <div class="api_key app-label info-rest">
                                                            <div class="top-texts">API Key:</div>
                                                            <h6>{this.state.apiKey ? this.state.apiKey : 'N/A'} {this.state.apiKey ? (this.state.apiKeyStatus == 1 ? <a id="disable_token_button" href="javascript:void(0);" class="btn btn-trans" onClick={() => this.disabletoken()} >Disable Token</a> : <span class="disabled">Disabled</span>) : <a  href = "javascript:void(0);" class="btn btn-trans" onClick={() => this.generatetoken()}>Generate Token</a>}</h6>
                                                        </div>
                                                        <div class="api_key app-label info-rest">
                                                            <div class="top-texts">SDK Name:</div>
                                                            <h6><div id="sdk_name" style={{width: "100%"}}>{this.state.package_name ? this.state.package_name : 'N/A'} </div>
                                                            <span id="sdk_change"><a href="javascript:void(0);" class="btn btn-trans" onClick={this.toggle1.bind(this)}>Change</a></span>
                                                            <span id="sdk_span_txt" style={{display: "none"}}>   
                                                            <input style={{width: "100%"}} type="text" id="sdk_name_txt" name="sdk_name" value={this.state.package_name} onChange={this.onChange.bind(this, 'package_name')}/> 
                                                            <input type="hidden" id="studios_id" name="studios_id" value={this.state.data.id} />
                                                            </span>
                                                            <span id="sdk_change_save" style={{display: "none"}}><a a href="javascript:void(0);" class="btn btn-trans" onClick={this.toggle2.bind(this)}>Save</a></span>
                                                            </h6>
                                                            </div>
                                                            <div class="customer_location app-label info-rest">
                                                            <div class="info-rest-loc">
                                                            <div class="top-texts">S3 Location:</div>
                                                            <h6 id="region_name">{this.state.data.region_name}</h6>
                                                            </div>
                                                            {this.state.data.package ?
                                            this.state.data.package.name == 'Muvi Standard' ?
                                                                <div></div>
                                                                :
                                                            <div class="filter customer_filter">
                                                                <select class="form-control customer_form-control">
                                                                    <option value="All_levels">Singapore</option>
                                                                    <option value="saab">Saab</option>
                                                                    <option value="mercedes">Mercedes</option>
                                                                    <option value="audi">Audi</option>
                                                                </select>
                                                                <i class="fa fa-angle-down s3-i" aria-hidden="true"></i>
                                                            </div>
                                                            :
                                            'NA'        
                                            }
                                                        </div>
                                                    </div>
                
                                <div class="app_conf">
                                    <div class="mob-conf">
                                        <div class="android_form app-tv configuration">
                                            <h6>Android Mobile/Android TV</h6>
                                            {this.state.android_view_state == 1 ?
                                this.getViewAndroidInfo() :
                                this.getEditAndroidInfo() }
                                        </div>
                                                </div>
                                                <div class="ios_form configuration tv-conf">
                                            <h6>iOS Mobile/Apple TV</h6>
                                            {this.state.ios_view_state == 1 ?
                                this.getViewiosInfo() :
                                this.getEditiosInfo()}
                                        </div>
                                    <div class="tv-conf">
                                        <div class="roku_form app-tv configuration">
                                            <h6>Roku TV</h6>
                                            {this.state.roku_view_state == 1 ?
                                this.getViewRokuInfo() :
                                this.getEditRokuInfo()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                                                    </div>

                <div class="tab-pane customer-details-tabs no-info-sec" id="Login">
                                {this.state.login_details.length > 0 ? this.state.login_details.map((details,key)=>
                        <div class="row">
                            <div class="box-body">
                                <div class="col-md-6">
                                    <span>{details.logout_at != '0000-00-00 00:00:00' && details.logout_at != ' ' ? details.email : ''}</span>
                                    <span>{details.login_at != '0000-00-00 00:00:00' && details.login_at != ' ' ? details.email : ''}</span>
                                </div>
                                <div class="col-md-6">
                                    <span>{details.logout_at != '0000-00-00 00:00:00' && details.logout_at != ' ' ? details.logout_at : ''}</span>
                                    <span style={{float: "right"}}>{details.login_at != '0000-00-00 00:00:00' && details.login_at != ' ' ? details.login_at : ''}</span>
                                </div>
                            </div>
                        </div>
                                            )
                                    :
                                    <span class="customer-detail-tab">Information not available</span>        
                                    }          
                    </div>
                                <div class="tab-pane customer-details-tabs no-info-sec" id="Upload">
                                {this.state.count > 0? this.getuploaddetails() : <span class="customer-detail-tab">Information not available</span>}                               
                    </div>
                </div>                                      
            }
            </div>
        </section>
    </div>
</div>
                                        );
                                }
                                }

                        export default CustomerDetails;


// WEBPACK FOOTER //
// ./src/components/customer/CustomerDetails.js